<div>
  <section>
    <div class="row mx-0 mb-2">
      <div class="col-10 px-0">
        <h3>
          Clients
          @if (!loading) {
            <span>
              - {{ clients.length | number: '' }}
            </span>
          }
        </h3>
      </div>
      <div class="col-2 px-0 text-end">
        @if (canManageClients) {
          <a
            class="nav-link"
            routerLink="/capture-admin/client-management/clients/new" routerLinkActive="active" class="btn btn-primary">
            Add New Client
          </a>
        }
      </div>
    </div>

    @if (!loading) {
      <div>
        <app-client-list
          [clients]="clients"
          [canManageClients]="canManageClients"
          [canManageClientConfigurations]="canManageClientConfigurations" />
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
  </section>
</div>
